import type { TOC } from '@ember/component/template-only'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { FastPhonicsReportsAccordion } from 'teacher-ui-client/components/side-nav/reading/fast-phonics-reports-accordion'

export const FastPhonicsProductGroup: TOC<unknown> = <template>
  <SideNavProductGroup @product="fast-phonics" class="rounded-lg bg-pink-50">
    <FastPhonicsReportsAccordion />
  </SideNavProductGroup>
</template>

export default FastPhonicsProductGroup
